import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import AddJobLocation from "../../components/Modals/AddJobLocation";
import JobLocationItem from "../../components/Items/JobsLocationItem";
import {
  jobLocationList
} from "../../helpers/api_helper";
import "react-toastify/dist/ReactToastify.css";
import {
  jobLocationDetails
} from "../../helpers/api_helper";
import moment from "moment/moment";
import Select from "react-select";
import { Loading } from "../../components/Elements/Loading";
import { Error } from "../../components/Elements/Error";
import { NoData } from "../../components/Elements/NoData";
import Pagination from "../../components/Elements/Pagination";

const Location = () => {
  // Query Client instance
  const queryClient = useQueryClient();

  // For pagination
  const [perPages, setPerPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 999999 },
  ]);
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);

  // For Managing Modals
  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const [isOne, setDataOne] = useState(false);

  // For Filtering Data 🔍
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");

  // To fetch Details of specific items when it needs to be edited
  const [editId, setEditId] = useState("");

  // Static status Radio buttons
  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: true, name: "Published", color: "success", current: false },
    { _id: false, name: "Draft", color: "warning", current: false },
  ]);

  // Dynamic query key for location 🗝️
  const queryJobLocation = ["jobLocation", keyword, status, limit, offset];

  // For opening Add Modal althogh not mandetory
  const addModal = () => {
    setIsAddModal(true);
  };

  // For fetching details of item
  const {
    data: details,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", editId],
    queryFn: async () => jobLocationDetails({ id: editId }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (editId !== "") {
      refetch();
    }
  }, [editId, refetch]);

  // Job Location List Component
  function JobLoactionList() {
    // Custom hook for fetching job location list
    function useJobLocation() {
      return useQuery({
        queryKey: queryJobLocation,
        queryFn: () =>
          jobLocationList({
            keyword: keyword,
            sortByField: "ordering",
            sortByValue: 1,
            status: status,
            limit: limit,
            offset: offset,
          }),
        keepPreviousData: true,
      });
    }

    const { data: jobLocation, error, isFetching } = useJobLocation();

    // Handling loading state 😑
    if (isFetching) {
      return <Loading />;
    }

    // Handling error state 🥴
    if (error) {
      return <Error />;
    }

    // Check if their is no data 🤨
    else if (jobLocation.data.length === 0) {
      return <NoData />;
    }

    // Renders the list
    else {
      return (
        // For Pagination
        <>
          {jobLocation.data.length > 0 &&
            jobLocation.data.map((item, index) => {
              return (
                <JobLocationItem
                  key={item._id}
                  index={index}
                  locationId={item._id}
                  type={item?.type}
                  createdDate={moment(new Date(item?.created_at)).format(
                    "Do MMM YY"
                  )}
                  updatedDate={moment(new Date(item?.updated_at)).format(
                    "Do MMM YY"
                  )}
                  query={queryJobLocation}
                  status={item?.status}
                  detailsFetch={refetch}
                  setEditId={setEditId}
                  setEditModal={setIsEditModal}
                />
              );
            })}

          <Pagination
            count={jobLocation.count}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
          />
        </>
      );
    }
  }

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters d-flex justify-content-between">
          <div className="input-items">
            <div className="input">
              <Select
                className="select-tag"
                isMulti={false}
                isClearable={true}
                options={perPages}
                value={selectedPageOpt || []}
                placeholder={"Per Page"}
                onChange={(e) => {
                  setSelectedPageOpt(e);
                }}
              />
            </div>
          </div>
          <div className="input-items">
            <Search
              placeholder={"Search..."}
              state={keyword}
              setState={setKeyword}
            />
          </div>

          <div className="input-items items-end gap-3 ms-auto">
            <Button
              label={""}
              labelClasses={""}
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={() => {
                queryClient.invalidateQueries(queryJobLocation);
                queryClient.removeQueries({
                  queryKey: ["jobLocation"],
                  type: "inactive",
                });
                setOffset(0);
                setKeyword("");
                setStatus("");
                setStatusStatic([]);
                setSelectedPageOpt([]);
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: true,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: false,
                      name: "Draft",
                      color: "warning",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
            />
            <Button
              label={"Add"}
              labelClasses={""}
              classes={""}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="radio-filters">
          <RadioGroup
            data={statusStatic}
            setData={setStatus}
            inputName={"status"}
          />
        </div>
      </div>
      <div className="location-list">
        <JobLoactionList />
      </div>

      {/* For Add Modal */}

      <Modal
        title={"Add Location type"}
        size={"sm"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(!isAddModal)}
      >
        <AddJobLocation
          modalClose={() => setIsAddModal(false)}
          query={queryJobLocation}
        />
      </Modal>

      {/* For Edit Modal*/}

      <Modal
        title={"Edit Location type"}
        size={"sm"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(!isEditModal)}
      >
        <AddJobLocation
          modalClose={() => setIsEditModal(false)}
          query={queryJobLocation}
          details={details}
          isFetching={isFetching}
        />
      </Modal>
    </>
  );
};

export default Location;
